export default __webpack_public_path__ + "files/71850e51ea04421286aaeb160a492fc1.png";